/** @jsxImportSource @emotion/react */
import classes from './style';
import { useContext } from 'react';
import { Il8nContext } from '../../../Helper/i18n';
import { Grid, DialogTitle, DialogContent, Button, Typography, Dialog, DialogActions } from '@mui/material';

function ConfirmationPopup(props) {
  const { open, onConfirm, onClose, showOptions } = props;
  const localeText = useContext(Il8nContext)
  

  return (
    <Dialog fullWidth maxWidth='xs' open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          onClose(event, reason);
        }
      }}
    >
      <DialogTitle className={classes.titleDiv}>
        <Grid container>
          <Grid item xs={12} style={classes.title}>
            {localeText?.uploadConfirmation}
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Typography>{`${localeText?.uploadSuccessfully} ${showOptions ? localeText?.uploadImages : ''}`}</Typography>
      </DialogContent>
      <DialogActions className={classes.content}>
        {
          showOptions
            ?
            <div style={{ display: 'flex', alignItems: 'center', textAlign: 'right' }}>
              <Button variant="contained" style={{ marginRight: '5px' }} onClick={onConfirm}>
                {localeText?.uploadYes}
              </Button>
              <Button color="primary" variant="contained" onClick={onClose}>
                {localeText?.uploadNo}
              </Button>
            </div>
            :
            <Button variant="contained" onClick={onClose}>{localeText?.uploadOk}</Button>
        }
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmationPopup;